module.exports = __webpack_public_path__ + "static/img/fb.65e1769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fb.png
// module id = pUJY
// module chunks = 1